export default class StocksplitService {
  getAll() {
    return fetch("https://api.tradersr.com/api/stocksplit")
      .then(res => res.json());
  }  
}